import { useCallback, useState } from 'react';
import { useSnackbar } from 'notistack';

import { getResponseMessage } from '../../../../../../utils/utils';
import { useFormatMessage } from '../../../../../../hooks';
import { CreateOffer, createOffer } from '../../../../../../crud/offer.crud';

export function useCreateOffer() {
  const { enqueueSnackbar } = useSnackbar();
  const [loadingCreate, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const fm = useFormatMessage();

  const create = useCallback(async (data: CreateOffer) => {
    setLoading(true);
    createOffer(data)
      .then(() => {
        enqueueSnackbar('Ценовое предложение успешно создано', { variant: 'success' });
        setSuccess(true);
      })
      .catch(e => {
        enqueueSnackbar(`${fm('ERROR')}: ${getResponseMessage(e)}`);
      })
      .finally(() => {
        setLoading(false);
        setTimeout(() => {
          setSuccess(false);
        }, 200);
      });
  }, []);

  return { create, loadingCreate, success };
}
